import Rpc from '@/config/apiServer/chain33rpc'
import Store from '../store/index'
import { ref, reactive, computed, ComputedRef, Ref } from 'vue'
import HomeMixins from './home'


interface MixinsType {
  Loading: Ref<boolean>,
  blocks: BlockType,
  pages: { currentPage: number, pageSize: number, total: number },
  pageChange: (page: number) => void,
  sizeChange: (size: number) => void,
  getNewBlocks: () => Promise<void>,
  maxHeight: ComputedRef
}
type BlockType = {
  list: {
    height: number,
    blockTime: number,
    txCount: number,
    hash: string,
    [propName: string]: number | string;
  }[]
}

export default function (): MixinsType {
  const { getLastBlock } = HomeMixins()
  const maxHeight = computed<number>(() => Store.state.maxHeight)
  const endHeight = ref(0)
  const blocks = reactive<BlockType>({
    list: new Array(20).fill({
      height: '',
      hash: '',
      txCount: '',
      blockTime: ''
    })
  })
  const pages = reactive({
    currentPage: 1,
    pageSize: 20,
    total: 0
  })
  const Loading = ref(false)

  // 获取最新区块
  async function getNewBlocks(): Promise<void> {
    await getLastBlock()
    if (endHeight.value < maxHeight.value) {
      pages.total = maxHeight.value
      getBlocks(maxHeight.value)
    }
  }
  // 获取区块信息
  async function getBlocks(height: number): Promise<void> {
    Loading.value = true
    endHeight.value = height
    const startHeight = (endHeight.value - pages.pageSize + 1) > 0 ? (endHeight.value - pages.pageSize + 1) : 0
    const res = await Rpc.getHeaders(startHeight, endHeight.value, true)
    if (res.error == null) {
      blocks.list = res.result.items.reverse()
      Loading.value = false
    }
  }
  // 翻页
  function pageChange(page: number): void {
    pages.currentPage = page
    endHeight.value = maxHeight.value - (page - 1) * pages.pageSize
    getBlocks(endHeight.value)
  }
  // 改变单页数据量
  function sizeChange(size: number): void {
    pages.pageSize = size
    pageChange(1)
  }

  return { blocks, pages, pageChange, sizeChange, maxHeight, getNewBlocks, Loading }
}